import { Injectable } from '@angular/core';
import {
  SortColumn,
  SortDirection,
} from '../home/informes/irm/sortable.directive';

@Injectable({ providedIn: 'root' })
export class SortService {
  compare = (v1: string | number, v2: string | number) =>
    v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

  sort(items: any, column: SortColumn, direction: string): any {
    window.console.log(items, column, direction);
    if (direction === '' || column === '') {
      return items;
    } else {
      return [...items].sort((a, b) => {
        const res = this.compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }
}
